import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiMenu, FiX, FiChevronDown, FiFileText, FiMessageSquare } from 'react-icons/fi';
import { NAV_LINKS } from './Navbar.js';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileAccordion, setMobileAccordion] = useState(null);
  const navRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  return (
    <header ref={navRef} className={`vb ${scrolled ? 'vb--scrolled' : ''}`}>
      <div className="vb__inner rt__container">
        <Link to="/" className="vb__logo">
          <img src="/assets/logo.png" alt="OrbisDMC" className="vb__logo-img" />
          <img src="/assets/M-logo.png" alt="OrbisDMC" className="vb__logo-mobile-img" />
        </Link>

        <nav className="vb__links">
          {NAV_LINKS.map((link) => (
            <div
              key={link.label}
              className="vb__item"
              onMouseEnter={() => link.dropdown && setOpenDropdown(link.label)}
              onMouseLeave={() => link.dropdown && setOpenDropdown(null)}
            >
              <NavLink to={link.path} className="vb__link">
                {link.label}
                {link.dropdown && <FiChevronDown className="vb__chevron" />}
              </NavLink>
              {link.dropdown && (
                <div className={`vb__dropdown ${openDropdown === link.label ? 'is-open' : ''}`}>
                  {link.dropdown.map((item) => (
                    <Link key={item.label} to={item.path} className="vb__dropdown-link">
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        <button
          className="vb__burger"
          aria-label="Open menu"
          onClick={() => setMobileOpen(true)}
        >
          <FiMenu />
        </button>
      </div>

      <div className={`vb__mobile ${mobileOpen ? 'is-open' : ''}`}>
        <div className="vb__mobile-head">
          <img src="/assets/M-logo.png" alt="OrbisDMC" className="vb__logo-img" />
          <button
            className="vb__close"
            aria-label="Close menu"
            onClick={() => setMobileOpen(false)}
          >
            <FiX />
          </button>
        </div>
        <div className="vb__mobile-links">
          {NAV_LINKS.map((link) => (
            <div key={link.label} className="vb__mobile-item">
              {link.dropdown ? (
                <>
                  <button
                    className="vb__mobile-link"
                    onClick={() =>
                      setMobileAccordion(mobileAccordion === link.label ? null : link.label)
                    }
                  >
                    {link.label}
                    <FiChevronDown
                      className={`vb__chevron ${mobileAccordion === link.label ? 'vb__chevron--rotated' : ''}`}
                    />
                  </button>
                  <div className={`vb__accordion ${mobileAccordion === link.label ? 'is-open' : ''}`}>
                    {link.dropdown.map((item) => (
                      <Link
                        key={item.label}
                        to={item.path}
                        className="vb__accordion-link"
                        onClick={() => setMobileOpen(false)}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                </>
              ) : (
                <Link
                  to={link.path}
                  className="vb__mobile-link"
                  onClick={() => setMobileOpen(false)}
                >
                  {link.label}
                </Link>
              )}
            </div>
          ))}
        </div>
        <div className="vb__quick-actions">
          <Link to="/news" className="vb__quick-link" onClick={() => setMobileOpen(false)}>
            <FiFileText />
            <span>News</span>
          </Link>
          <Link to="/contact" className="vb__quick-link" onClick={() => setMobileOpen(false)}>
            <FiMessageSquare />
            <span>Contact Us</span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
